import { render, staticRenderFns } from "./Course-item.vue?vue&type=template&id=0292b240&scoped=true&"
import script from "./Course-item.vue?vue&type=script&lang=js&"
export * from "./Course-item.vue?vue&type=script&lang=js&"
import style0 from "./Course-item.vue?vue&type=style&index=0&id=0292b240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0292b240",
  null
  
)

export default component.exports